export const ASSIGNMENT_STATES = Object.freeze({
  completed: 'Completed',
  awaitingFeedback: 'Awaiting feedback',
  pendingSubmission: 'Pending submission'
});
